import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { deliveryClient } from '../../lib/connect/clients';
const MY_KEY = 'notification-preferences-mine';
const COMPANY_KEY = 'notification-preferences-company';
export function useMyNotificationPreferences(companyId) {
    return useQuery({
        queryKey: [
            MY_KEY,
            companyId
        ],
        queryFn: async ()=>(await deliveryClient.getMyNotificationPreferences({
                companyId
            })).kinds,
        enabled: !!companyId
    });
}
export function useUpdateMyNotificationPreferences(companyId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (u)=>(await deliveryClient.updateMyNotificationPreferences({
                companyId,
                changes: u.changes ?? [],
                resetAll: u.resetAll ?? false
            })).kinds,
        onSuccess: (kinds)=>{
            qc.setQueryData([
                MY_KEY,
                companyId
            ], kinds);
        }
    });
}
export function useCompanyNotificationDefaults(companyId, enabled) {
    return useQuery({
        queryKey: [
            COMPANY_KEY,
            companyId
        ],
        queryFn: async ()=>(await deliveryClient.getCompanyNotificationDefaults({
                companyId
            })).kinds,
        enabled: !!companyId && enabled
    });
}
export function useUpdateCompanyNotificationDefaults(companyId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async (u)=>(await deliveryClient.updateCompanyNotificationDefaults({
                companyId,
                changes: u.changes ?? [],
                resetAll: u.resetAll ?? false
            })).kinds,
        onSuccess: (kinds)=>{
            qc.setQueryData([
                COMPANY_KEY,
                companyId
            ], kinds);
            // Every person's "Default: …" reads the company layer.
            qc.invalidateQueries({
                queryKey: [
                    MY_KEY,
                    companyId
                ]
            });
        }
    });
}
